<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-06 13:22:20
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-06-13 13:48:46
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/views/index/enterpriseData.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <div class="meetingData-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="12" />
      <vab-query-form-right-panel :span="12">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item>
            <el-input v-model.trim="queryForm.likeEnterprise" clearable placeholder="请输入企业名称" />
          </el-form-item>

          <el-form-item>
            <el-input v-model.trim="queryForm.likeName" clearable placeholder="请输入姓名" />
          </el-form-item>

          <el-form-item>
            <el-input v-model.trim="queryForm.likePhone" clearable placeholder="请输入手机号" />
          </el-form-item>

          <el-form-item>
            <el-button :icon="Search" type="primary" @click="queryData">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>

    <el-table v-loading="listLoading" border :data="list">
      <el-table-column align="center" label="机构 code" prop="enterpriseCode" show-overflow-tooltip />
      <el-table-column align="center" label="企业名称" prop="enterpriseName" show-overflow-tooltip />
      <el-table-column align="center" label="创建时间" prop="createTime" show-overflow-tooltip />
      <el-table-column align="center" label="办个展（场）" prop="holdExhibitionCount" show-overflow-tooltip />
      <el-table-column align="center" label="办个会（场）" prop="holdMeetingCount" show-overflow-tooltip />
      <el-table-column align="center" label="姓名" prop="name" show-overflow-tooltip />
      <el-table-column align="center" label="手机号" prop="phone" show-overflow-tooltip />
      <el-table-column align="center" label="会议码">
        <template #default="{ row }">
          <el-image :preview-src-list="[row.qrCode]" :src="row.qrCode" :zoom-rate="1.2" />
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" show-overflow-tooltip width="195">
        <template #default="{ row }">
          <el-button type="text" @click="handleEdit(row, 'EXH')">展会列表</el-button>
          <el-button type="text" @click="handleEdit(row, 'MEET')">会议列表</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.pageNo"
      :layout="layout"
      :page-sizes="pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />

    <enterpriseByExh ref="editRef" />
    <enterpriseByMeet ref="editRefMeet" />
  </div>
</template>

<script>
  import { defineAsyncComponent, defineComponent, getCurrentInstance, onMounted, reactive, toRefs, computed } from 'vue'
  import { getAllEnterprise } from '@/api/workBench'
  import { exportVisitorRegisterReport } from '@/api/exhibitionManage'
  import { Delete, Plus, Search } from '@element-plus/icons'
  import { useStore } from 'vuex'
  import { parseTime } from '@/utils/index'
  import enterpriseByExh from './components/enterpriseByExh.vue'
  import enterpriseByMeet from './components/enterpriseByMeet.vue'
  export default defineComponent({
    name: 'MeetingData',
    components: {
      enterpriseByExh,
      enterpriseByMeet,
    },
    setup() {
      const { proxy } = getCurrentInstance()

      const store = useStore()
      const state = reactive({
        generateWxRef: null,
        list: [],
        listLoading: true,
        layout: 'prev, pager, next,total,sizes',
        total: 0,
        pageSize: [10, 20, 30, 50, 100],
        selectRows: '',
        queryForm: {
          pageNum: 1,
          pageSize: 10,
          likeEnterprise: '',
          likeName: '',
          likePhone: '',
        },
        editRef: null,
        editRefMeet: null,
        fullscreenLoading: false,
      })

      const handleEdit = (row, type) => {
        row.type = type
        if (type == 'EXH') {
          state.editRef.showEdit(row)
        } else {
          state.editRefMeet.showEdit(row)
        }
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }
      const queryData = () => {
        state.queryForm.pageNum = 1
        fetchData()
      }
      const fetchData = async () => {
        state.listLoading = true
        const { data } = await getAllEnterprise(state.queryForm)
        state.list = data.list
        state.total = data.total
        state.listLoading = false
      }
      onMounted(() => {
        fetchData()
      })

      const download = (row) => {
        state.fullscreenLoading = true
        exportVisitorRegisterReport(row.meetingCode).then((res) => {
          state.fullscreenLoading = false
          if (res.data.success) {
            window.open(res.data.fileUrl)
          }
        })
      }
      const handleDate = (val) => {
        return parseTime(val)
      }

      const open = (row) => {
        console.log(row)
        const qrCodeParams = {
          autoColor: false,
          b: 0,
          env: '',
          g: 0,
          jumpPath: row.meetingCode,
          jumpType: '',
          logo: '',
          params: `{"meetingCode":"${row.meetingCode}"}`,
          path: 'pages/index/index',
          r: 0,
          scenesType: 'USER_HOLD_MEETING',
          width: 1280,
        }
        state['generateWxRef'].handleOpen(row, qrCodeParams)
      }

      return {
        ...toRefs(state),
        handleSizeChange,
        handleCurrentChange,
        queryData,
        fetchData,
        Delete,
        Plus,
        Search,
        download,
        handleDate,
        open,
        handleEdit,
      }
    },
  })
</script>

<style>
  .meetingData-management-container .el-image-viewer__canvas {
    background: #fff;
  }
</style>
